// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79f100bf-168":"dcd68cfe4d3390a83893","79f100bf-452":"f8e816c1fc690825ca73","79f100bf-379":"37e80701f0bc87896905","79f100bf-83":"a6dba68079d2f5007fb1"}[chunkId] + ".js";
};